var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonthView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.48148 1.11111C1.72115 1.11111 1.11111 1.74431 1.11111 2.48148V17.5185C1.11111 18.2789 1.74431 18.8889 2.48148 18.8889H17.5185C18.2857 18.8889 18.8948 18.2835 18.9259 17.5448V2.48148C18.9259 1.72115 18.2927 1.11111 17.5556 1.11111H2.48148ZM0 2.48148C0 1.14458 1.09367 0 2.48148 0H17.5556C18.8925 0 20.037 1.09367 20.037 2.48148V17.5655L20.0367 17.5754C19.9891 18.9067 18.8963 20 17.5185 20H2.48148C1.14458 20 0 18.9063 0 17.5185V2.48148Z",
    fill: "#524F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6291 5.18533H0.740234V4.07422H19.6291V5.18533Z",
    fill: "#524F4F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9C6 8.44772 5.55228 8 5 8H4C3.44772 8 3 8.44772 3 9V10C3 10.5523 3.44772 11 4 11H5C5.55228 11 6 10.5523 6 10V9Z",
    fill: "#524F4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9C11.5 8.44772 11.0523 8 10.5 8H9.5C8.94772 8 8.5 8.44772 8.5 9V10C8.5 10.5523 8.94772 11 9.5 11H10.5C11.0523 11 11.5 10.5523 11.5 10V9Z",
    fill: "#524F4F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9C17 8.44772 16.5523 8 16 8H15C14.4477 8 14 8.44772 14 9V10C14 10.5523 14.4477 11 15 11H16C16.5523 11 17 10.5523 17 10V9Z",
    fill: "#524F4F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 14C6 13.4477 5.55228 13 5 13H4C3.44772 13 3 13.4477 3 14V15C3 15.5523 3.44772 16 4 16H5C5.55228 16 6 15.5523 6 15V14Z",
    fill: "#524F4F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14C11.5 13.4477 11.0523 13 10.5 13H9.5C8.94772 13 8.5 13.4477 8.5 14V15C8.5 15.5523 8.94772 16 9.5 16H10.5C11.0523 16 11.5 15.5523 11.5 15V14Z",
    fill: "#524F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthView);
export default __webpack_public_path__ + "static/media/month-view.b80a89df0744c70493c406f3ed06d0dc.svg";
export { ForwardRef as ReactComponent };